var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactsMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 4.75H2.8125C1.26488 4.75 0 6.00931 0 7.5625V24.4375C0 25.9912 1.26569 27.25 2.8125 27.25H29.1875C30.7351 27.25 32 25.9907 32 24.4375V7.5625C32 6.00894 30.7345 4.75 29.1875 4.75ZM28.7556 6.625C27.8463 7.53731 17.1653 18.2531 16.7265 18.6934C16.36 19.061 15.6402 19.0612 15.2735 18.6934L3.24437 6.625H28.7556ZM1.875 24.0928V7.90719L9.94156 16L1.875 24.0928ZM3.24437 25.375L11.2653 17.328L13.9456 20.0171C15.0439 21.119 16.9565 21.1186 18.0545 20.0171L20.7348 17.3281L28.7556 25.375H3.24437ZM30.125 24.0928L22.0584 16L30.125 7.90719V24.0928Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsMail);
export default __webpack_public_path__ + "static/media/contacts-mail.b8cf8e3a986574765f037eaa4037b5df.svg";
export { ForwardRef as ReactComponent };